import * as forms from '@/libraries/forms/forms'

const fields = [
  new forms.FormFieldGroup({
    name: 'Profile',
    fields: [
      new forms.FormField({
        type: forms.FormFieldType.TEXT,
        identifier: 'first_name',
        label: 'First Name',
        placeholder: 'John',
        inline: true,
        required: true,
      }),
      new forms.FormField({
        type: forms.FormFieldType.TEXT,
        identifier: 'last_name',
        label: 'Last Name',
        placeholder: 'Doe',
        inline: true,
        required: true,
      }),
      new forms.FormField({
        type: forms.FormFieldType.RADIO,
        label: 'Tenant of Record',
        identifier: 'tor',
        multiselect: false,
        options: [
          new forms.FormFieldSelectOption('Yes', 'true'),
          new forms.FormFieldSelectOption('No', 'false'),
        ],
        inline: true,
        required: false,
      }),
      new forms.FormField({
        type: forms.FormFieldType.TEXT,
        identifier: 'unit',
        label: 'Unit',
        placeholder: '1A',
        inline: true,
        required: false,
      }),
      new forms.FormField({
        type: forms.FormFieldType.RADIO,
        label: 'Badge Check Status',
        identifier: 'badge_check_status',
        multiselect: false,
        options: [
          new forms.FormFieldSelectOption('OK', 'ok'),
          new forms.FormFieldSelectOption('Not OK', 'not_ok'),
          new forms.FormFieldSelectOption('Not Checked', 'not_checked'),
        ],
        inline: true,
        required: false,
      }),
    ],
  }),
  new forms.FormFieldGroup({
    name: 'Entry Credentials',
    identifier: 'credentials',
    layout: {
      flexProperties: {
        wrap: true,
      },
    },
    fields: [
    ],
    fieldTemplate: {
      type: forms.FormFieldType.TEXT,
      identifier: `credential_`,
      label: `Credential`,
      placeholder: '123',
      layout: {
        flexProperties: {
          grow: 2,
        },
      },
      required: false,
      inline: true,
    },
  }),
  new forms.FormFieldGroup({
    name: 'Photos',
    fields: [
      new forms.FormField({
        type: forms.FormFieldType.FILE,
        identifier: 'image',
        label: 'Tenant Photo',
        required: false,
        inline: true,
        fileTypes: 'image/*',
      }),
    ],
  }),
]

function updateImage (submission, image) {
  if (image && image.data_b64 && image.data_b64.startsWith('http')) {
    console.log('Image is not edited. (It has an HTTP url.)')
    return
  }
  if (image.data_b64) {
    // handled by the node server before sending to S3
    // image.data_b64 = image.data_b64.split(',')[1]
    submission.identity_info.image = image
  } else {
    // delete submission.identity_info.images
  }
}

const submissionRules = [
  new forms.FormTemplateRule('Format Identity Submission', function (submission, index, parameters) {
    const credentialKeys = Object.keys(submission.fields).filter(key => key.includes('credential_'))

    let identityProfile = {
      domain_uuid: submission.metadata.domain_uuid,
      identity_info: {
        first_name: submission.fields.first_name,
        last_name: submission.fields.last_name,
        unit: submission.fields.unit,
        credentials: credentialKeys.map(credential => submission.fields[credential]),
        badge_check_status: submission.fields.badge_check_status,
      },
    }
    if (submission.fields.tor === 'true') {
      identityProfile.identity_info.occupancy_role = 'tor'
    }
    if (submission.fields.image) {
      updateImage(identityProfile, submission.fields.image)
    }
    return identityProfile
  }),
]

const initializationRules = [
  new forms.FormTemplateRule('Convert Identity Into Submission', function (identity, index, parameters) {
    const initialValues = {
      domain_uuid: identity.domain_uuid,
      first_name: identity.first_name,
      last_name: identity.last_name,
      tor: identity.tor ? 'true' : 'false',
      unit: identity.unit,
      image: identity.image,
      badge_check_status: identity.badge_check_status,
    }
    fields[1].fields = []
    if (identity.credentials) {
      initialValues.credentials = []
      identity.credentials.forEach((credential, index) => {
        fields[1].fields.push(
          new forms.FormField({
            type: forms.FormFieldType.TEXT,
            identifier: `credential_${index + 1}`,
            label: `Credential ${index + 1}`,
            placeholder: '123',
            defaultValue: credential.number,
            layout: {
              flexProperties: {
                grow: 2,
              },
            },
            required: false,
            inline: true,
          }),
        )
        initialValues.credentials.push(credential)
      })
    }

    const submission = new forms.FormSubmission('io.owal.identity', fields, initialValues)
    return submission
  }),
]

const validationRules = [
  { error: 'Identity must be assigned either credential ID or Unit',
    isValid: function (submission) {
      const validCredentials = Object.keys(submission.fields).filter(key => key.includes('credential_')).filter((credential) => submission.fields[credential].length > 0)
      if ((submission.fields.unit && submission.fields.unit.length > 0) || (validCredentials.length > 0)) {
        return true
      } else {
        return false
      }
    },
  },
]
const submissionTemplate = new forms.FormTemplate('Upload Face Credential', submissionRules)
const initializationTemplate = new forms.FormTemplate('Upload Face Credential', initializationRules)

export const addCredential = new forms.Form('identity', fields, submissionTemplate, initializationTemplate, validationRules)
